import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import moment from "moment";
import { PhoneNumberFormat, PhoneNumberUtil } from "google-libphonenumber";
import { OrganisationService } from 'src/app/services/organisation/organisation.service';
import { forkJoin } from 'rxjs';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-edit-pulse-recipient',
  templateUrl: './edit-pulse-recipient.component.pug',
  styleUrls: ['./edit-pulse-recipient.component.scss'],
  standalone: false
})
export class EditPulseRecipientComponent implements OnInit {
  @Input() recipientToEdit: any;
  @Output() closeEditEvent = new EventEmitter();
  @Output() updatedRecipient = new EventEmitter();
  recipientRow = {};
  closeComponent = false;
  recipientLastName!: string;
  disableSend = true;
  @ViewChild("editPulseRecipientForm") editPulse: any;
  phoneUtil = PhoneNumberUtil.getInstance();
  departments: any;
  personalEmailAddressTooltip = $localize`Only required if work email address is unavailable.`
  loading = false;
  domains: any;
  valid_work_email = false;
  selectedEmail:any;
  selectedDomain: any;
  initialDepartment = false;
  editDepartmentDropdownLabel = $localize`Select department`;

  constructor(private organisationService: OrganisationService, permissions: PermissionsService) {
  }

  ngOnInit(): void {
    this.recipientRow = {...this.recipientToEdit['recipient']};
    this.selectedDomain = this.recipientRow['work_email'] ? this.recipientRow['work_email'].split('@')[1] : '';
    this.selectedEmail = this.recipientRow['work_email'] ? this.recipientRow['work_email'].split('@')[0] : '';
    this.disableCheck();
    this.loading = true;
    forkJoin({ orgDetails: this.organisationService.getOrganisation(), orgDepartments: this.organisationService.getAllDepartments(true)})
    .subscribe(({ orgDetails, orgDepartments }) => {
    this.domains = orgDetails['domains'];
    this.departments = orgDepartments['departments'].filter(each => !each.disabled).map(each => ({ key: each.department, value: each.department }))
    this.departments.forEach(each => {
      if(each.value === this.recipientRow['department']) {
        this.initialDepartment = true;
        this.editDepartmentDropdownLabel = this.truncateText(each.value, 18)
        return;
      }
    })
    this.loading = false;
    });
  }

  isDirty(): boolean {
    return this.editPulse.markAsDirty();
  }

  closeEdit() {
    this.closeComponent = true;
    this.closeEditEvent.emit(this.closeComponent);
  }

  disableCheck() {
    if (this.isFieldEmpty(this.recipientRow['first_name']) || this.isFieldEmpty(this.recipientRow['last_name']) || this.isFieldEmpty(this.recipientRow['mobile_phone'])) {
      this.disableSend = true;
    } else if (this.isFieldEmpty(this.selectedEmail)) {
      if (this.isFieldEmpty(this.recipientRow['personal_email'])) {
        this.disableSend = true;
      } else {
        this.disableSend = false;
        this.checkDataTrim();
      }
    } else if (this.isFieldEmpty(this.recipientRow['personal_email'])) {
      if (this.isFieldEmpty(this.selectedEmail)) {
        this.disableSend = true;
      } else {
        this.disableSend = false;
        this.checkDataTrim();
      }
    }
    else {
      this.disableSend = false;
      this.checkDataTrim();
    }
  }

  checkDataTrim(){
    if (this.recipientRow['first_name'].trim() || this.recipientRow['last_name'].trim() || (this.selectedEmail.trim() || this.recipientRow['personal_email'].trim()) || this.recipientRow['mobile_phone'].trim()) {
      this.valid_work_email = (this.selectedEmail.indexOf('@') > -1) ? true : false;
      if (this.valid_work_email) {
        this.disableSend = true;
      } else {
        this.disableSend = false;
        this.recipientRow['work_email']=(this.selectedEmail==='')? '': this.selectedEmail+'@'+this.selectedDomain;
      }
    }
  }

  checkClass(recipient, fields) {
    for (let field of fields) {
      if (recipient.meta.error_fields.indexOf(field) != -1) {
        return 'error';
      } else if (recipient.meta.warning_fields.indexOf(field) != -1) {
        return 'warning';
      }
    }
    return 'none';
  }

  saveDetails(recipient) {
    let payloadToEdit = {
      "recipient": recipient,
    }
    if (recipient['first_name'] && recipient['last_name'] && (recipient['work_email']||recipient['personal_email'] )&& this.recipientRow['mobile_phone']) {
      this.disableSend = false;
      this.updatedRecipient.emit(payloadToEdit);
      this.closeEdit();
    }
  }

  phoneUpdate(event) {
    this.editPulse.control.markAsDirty();
    this.recipientRow['country_code'] = event['country_code'];
    this.recipientRow['mobile_phone'] = event['mobile_phone'];
    let phone = event['country_code'] + event['mobile_phone'];
    let parsedPhone = '';
    try {
      parsedPhone = this.phoneUtil.parseAndKeepRawInput(phone);
      this.recipientRow['mobile'] = this.phoneUtil.format(parsedPhone, PhoneNumberFormat.INTERNATIONAL);
    } catch (e) {
      // needs to be handled in a better way
      console.log("Phone number parsing error: ", e);
    }
    this.disableCheck();
  }

  isFieldEmpty(field) {
    if (field == null || field == "" || field == 'null') {
      return true;
    } else {
      return false;
    }
  }

  selectDepartment(department) {
    this.editPulse.control.markAsDirty();
    this.recipientRow['department'] = department.value;
    // Clear the editDepartmentDropdownLabel to ensure proper update
    this.editDepartmentDropdownLabel = '';
    // Introduce a small delay before assigning the new value to allow the UI to update
    setTimeout(() => {
      this.editDepartmentDropdownLabel = this.truncateText(department.value, 18);
    }, 100);
    this.disableCheck();
  }

  checkWorkEmail(workEmail) {
    if (!this.selectedEmail) return true;
    const mailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$/
    return mailRegex.test(workEmail)
  }

  truncateText(text: string, maxLength: number): string {
    if (text.length <= maxLength) {
      return text;
    }
    return text.substring(0, maxLength) + "...";
  }
}
